import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LANGS = ["it", "en", "de", "fr"];
export const DEFAULT_LANG = "it";

export const LANG_LABELS = {
  it: "IT",
  en: "EN",
  de: "DE",
  fr: "FR",
};

// Fase 1: risorse minime per la "chrome" UI. Le traduzioni dei contenuti
// (mock.js) arriveranno nella Fase 2. Il fallback resta sempre l'italiano.
const resources = {
  it: { common: { langName: "Italiano" } },
  en: { common: { langName: "English" } },
  de: { common: { langName: "Deutsch" } },
  fr: { common: { langName: "Français" } },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  defaultNS: "common",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
